<template>
  <div style="height: 100%">
    <div class="d-flex flex-column justify-center align-center" style="height: calc(90%)">
      <lottie-animation v-cloak
                        ref="animation"
                        :animationData="errorAnimation"
                        :autoPlay="false"
                        style="max-width: 200px"></lottie-animation>
      <v-fade-transition>
        <div v-if="show" class="pa-4 d-flex flex-column align-center text-center">
          <div class="text-h4">Oops</div>
          <div class="text-body-1 mt-4">{{$t('CurrentlyNotAcceptingOrders')}}</div>
<!--          <div v-if="shopInfo && (shopInfo.emailAddress || shopInfo.telephone)" class="d-flex justify-center px-3 mt-6">-->
<!--            <div style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr))">-->
<!--              <div v-if="shopInfo.telephone">-->
<!--                <v-img :src="phoneIcon" contain height="48"/>-->
<!--                <div class="mt-2 text-caption text-center">-->
<!--                  <a :href="'tel:'+shopInfo.telephone">{{ shopInfo.telephone }}</a>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div v-if="shopInfo.emailAddress">-->
<!--                <v-img :src="emailIcon" contain height="48"/>-->
<!--                <div class="mt-2 text-caption text-center px-3">{{ shopInfo.emailAddress }}</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </v-fade-transition>
    </div>

  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue' // import lottie-web-vue
import errorAnimation from '@/assets/error.json'
import phoneIcon from '@/assets/images/698@2x.png'
import emailIcon from '@/assets/images/699@2x.png'


export default {
  components: {LottieAnimation},
  name: "NoActivePage",
  data: function () {
    return {
      show: false,
      errorAnimation,
      phoneIcon,
      emailIcon
    };
  },
  props: {
    shopInfo: {}
  },
  mounted() {
    setTimeout(() => {
      this.$refs.animation.play()
      setTimeout(() => {
        this.show = true
      }, 1000)
    }, 1000)
  }
}
</script>

<style scoped>

</style>
